export default __webpack_public_path__ + "static/media/credit.b33b0a9b.svg";